//import colors from 'vuetify/lib/util/colors'
//const colors = require('vuetify/lib/util/colors');

const tenantConfig = {
    default: {
        id: 'default',
        name: 'sodisp.com',
        navPostfix: 'default',
        title: 'sodisp - Challenge Platform',
        isDefault: true,
        showFeatures: true,
        accountProviders: ['strava','garmin','sodisp'],
        scssVariables: 'src/styles/tenants/default',
        homeUrl: 'https://sodisp.com/',
        profileFaqUrl: 'https://sodisp.freshdesk.com/support/solutions/77000092784',
        eventManagerFaqUrl: 'https://sodisp.freshdesk.com/support/solutions/77000088875',
        headerLogoUrl: '/images/logo-header.svg',
        logoUrl: '/images/logo.svg',
        contactEmail:  'hello@sodisp.com',
        theme: {
            primary: "#F46524",
            secondary: '#008AFF', // <-- new
            progress: '#FFEB3B', // <-- new//colors.yellow.base,
            accent: '#005398',
            green: '#00B46E',
            header: '#F46524', // <-- new
            gradient: '#FFC107', // <-- new
            eventmanager: '#00B46E', // <-- new
            profile: '#005398', // <-- new
          },
          subtenants: Object.freeze([
            {
                id: 'vruk',
                host: 'vr.co.uk',
                name: 'Virtual Racing UK',
                title: 'Virtual Racing UK',
                description: '',
                contactEmail: 'info@vr.co.uk',
                homeUrl: 'https://sodisp.com/',
                customCss: 'vruk.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
            },
            {
                id: 'asdeporte',
                host: 'retos.asdeporte.com',
                name: 'Asdeporte connected challenges',
                title: 'Asdeporte connected challenges',
                description: 'Transformamos la vida de las personas a través del Deporte.',
                homeUrl: 'https://retos.asdeporte.com/',
                logoUrl: '/images/tenants/asdeporte-logo.png',
                favIconUrl: '/images/tenants/asdeporte-favicon.png',
                headerLogoUrl: '/images/tenants/asdeporte-logo.png',
                accountProviders: ['asdeporte'],
                customCss: 'asdeporte.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#FF6A00",
                    secondary: '#2B2826', // <-- new
                    progress: '#FF6A00', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#2B2826', // <-- new
                    gradient: '#000', // <-- new
                    eventmanager: '#2B2826', // <-- new
                    profile: '#FF5255', // <-- new
                }
            },


            // DEMO TENANTS
            {
                id: 'athleta-demo',
                host: 'athleta-demo.sodisp.com',
                name: 'athleta connected challenges',
                title: 'athleta connected challenges',
                description: 'Welcome to the Athleta Connected Fitness Community! Get fit and challenge yourself. Connect your favorite GPS watch or app and get started!',
                homeUrl: 'https://athleta-demo.sodisp.com/',
                logoUrl: '/images/demos/athleta.png',
                headerLogoUrl: '/images/demos/athleta.png',
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#942699",
                    secondary: '#008AFF', // <-- new
                    progress: '#942699', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'brooks-demo',
                host: 'brooks-demo.sodisp.com',
                name: 'Brooks connected challenges',
                title: 'Brooks connected challenges',
                description: 'Welcome to the Brooks Connected Fitness Community! Get fit and challenge yourself. Connect your favorite GPS watch or app and get started!',
                homeUrl: 'https://brooks-demo.sodisp.com/',
                logoUrl: '/images/demos/brooks.png',
                headerLogoUrl: '/images/demos/brooks.png',
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#0363F7",
                    secondary: '#008AFF', // <-- new
                    progress: '#0363F7', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'coros-demo',
                host: 'coros-demo.sodisp.com',
                name: 'COROS connected challenges',
                title: 'COROS connected challenges',
                description: 'Welcome to the COROS Connected Fitness Community! Get fit and challenge yourself. Connect with your COROS account and your activities will be synced automatically!',
                homeUrl: 'https://coros-demo.sodisp.com/',
                logoUrl: '/images/demos/coros.png',
                headerLogoUrl: '/images/demos/coros.png',
                accountProviders: ['coros'],
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#F6283B",
                    secondary: '#008AFF', // <-- new
                    progress: '#0363F7', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'inov-8-demo',
                host: 'inov-8-demo.sodisp.com',
                name: 'Inov-8 connected challenges',
                title: 'Inov-8 connected challenges',
                description: 'Welcome to the Inov-8 Connected Fitness Community! Get fit and challenge yourself. Connect your favorite GPS watch or app and get started!',
                homeUrl: 'https://inov-8-demo.sodisp.com/',
                logoUrl: '/images/demos/inov-8.png',
                headerLogoUrl: '/images/demos/inov-8.png',
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#000000",
                    secondary: '#008AFF', // <-- new
                    progress: '#FFEB3B', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'lululemon-demo',
                host: 'lululemon-demo.sodisp.com',
                name: 'lululemon connected challenges',
                title: 'lululemon connected challenges',
                description: 'Welcome to the lululemon Connected Fitness Community! Get fit and challenge yourself. Connect your favorite GPS watch or app and get started!',
                homeUrl: 'https://lululemon-demo.sodisp.com/',
                logoUrl: '/images/demos/lululemon.png',
                headerLogoUrl: '/images/demos/lululemon.png',
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#CF052B",
                    secondary: '#008AFF', // <-- new
                    progress: '#CF052B', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'polar-demo',
                host: 'polar-demo.sodisp.com',
                name: 'Polar connected challenges',
                title: 'Polar connected challenges',
                description: 'Welcome to the Polar Connected Fitness Community! Get fit and challenge yourself. Connect with your Polar account and your activities will be synced automatically!',
                homeUrl: 'https://polar-demo.sodisp.com/',
                logoUrl: '/images/demos/polar.png',
                headerLogoUrl: '/images/demos/polar.png',
                accountProviders: ['polar'],
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#ED1638",
                    secondary: '#008AFF', // <-- new
                    progress: '#ED1638', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'salomon-demo',
                host: 'salomon-demo.sodisp.com',
                name: 'Salomon connected challenges',
                title: 'Salomon connected challenges',
                description: 'Welcome to the Salomon Connected Fitness Community! Get fit and challenge yourself. Connect your favorite GPS watch or app and get started!',
                homeUrl: 'https://salomon-demo.sodisp.com/',
                logoUrl: '/images/demos/salomon.png',
                headerLogoUrl: '/images/demos/salomon.png',
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#FF0B0A",
                    secondary: '#008AFF', // <-- new
                    progress: '#FFEB3B', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#FF0B0A', // <-- new
                    gradient: '#EC7102', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },
            {
                id: 'suunto-demo',
                host: 'suunto-demo.sodisp.com',
                name: 'Suunto connected challenges',
                title: 'Suunto connected challenges',
                description: 'Welcome to the Suunto Connected Fitness Community! Get fit and challenge yourself. Connect with your Suunto account and your activities will be synced automatically!',
                homeUrl: 'https://suunto-demo.sodisp.com/',
                logoUrl: '/images/demos/suunto.png',
                headerLogoUrl: '/images/demos/suunto.png',
                accountProviders: ['suunto'],
                customCss: 'demos.css',
                isDefault: false,
                showFeatures: false,
                navPostfix: 'minimal',
                customHomePostfix: 'whitelabel',
                theme: {
                    primary: "#E1001A",
                    secondary: '#008AFF', // <-- new
                    progress: '#FFEB3B', // <-- new//colors.yellow.base,
                    accent: '#005398',
                    green: '#00B46E',
                    header: '#fff', // <-- new
                    gradient: '#eee', // <-- new
                    eventmanager: '#00B46E', // <-- new
                    profile: '#005398', // <-- new
                }
            },

        ]),
    },
    demo: {
        id: 'demo',
        name: 'sodisp.com',
        navPostfix: 'minimal',
        title: 'sodisp - Challenge Platform',
        isDefault: false,
        showFeatures: false,
        accountProviders: ['sodisp', 'garmin', 'strava'],
        scssVariables: 'src/styles/tenants/demo',
        homeUrl: 'https://demo.sodisp.com/',
        headerLogoUrl: 'https://sodisp.imgix.net/~text?txt-color=fff&txt-pad=0&txt64=RGVtbyBQbGF0Zm9ybQ&txt-font=Avenir%20Next%20Condensed%2CBold&w=200&txt-size=32&fm=png',
        logoUrl: 'https://sodisp.imgix.net/~text?txt-color=F46524&txt-pad=0&txt64=RGVtbyBQbGF0Zm9ybQ&txt-font=Avenir%20Next%20Condensed%2CBold&w=200&txt-size=32&fm=png',
        contactEmail:  'hello@sodisp.com',
        customHomePostfix: 'whitelabel',
        theme: {
            primary: "#F46524",
            secondary: '#008AFF', // <-- new
            progress: '#FFEB3B', // <-- new //colors.yellow.base,
            accent: '#005398',
            green: '#00B46E',
            header: '#00B46E', // <-- new
            gradient: '#00995B', // <-- new
            eventmanager: '#00B46E', // <-- new
            profile: '#005398', // <-- new
        },
        subtenants: Object.freeze([
        ]),
    },
    cofi: {
        id: 'cofi',
        name: 'corporatefitness.app',
        navPostfix: 'minimal',
        title: 'corporatefitness.app - Connected Corporate Fitness Programs',
        isDefault: false,
        showFeatures: false,
        accountProviders: ['sodisp', 'garmin', 'strava'],
        scssVariables: 'src/styles/tenants/cofi',
        homeUrl: 'https://corporatefitness.app/',
        headerLogoUrl: 'https://sodisp.imgix.net/~text?txt-color=fff&txt-pad=0&txt64=RGVtbyBQbGF0Zm9ybQ&txt-font=Avenir%20Next%20Condensed%2CBold&w=200&txt-size=32&fm=png',
        logoUrl: 'https://sodisp.imgix.net/~text?txt-color=F46524&txt-pad=0&txt64=RGVtbyBQbGF0Zm9ybQ&txt-font=Avenir%20Next%20Condensed%2CBold&w=200&txt-size=32&fm=png',
        contactEmail:  'hello@corporatefitness.app',
        customHomePostfix: 'whitelabel',
        theme: {
            primary: "#F46524",
            secondary: '#008AFF', // <-- new
            progress: '#FFEB3B', // <-- new //colors.yellow.base,
            accent: '#005398',
            green: '#00B46E',
            header: '#00B46E', // <-- new
            gradient: '#00995B', // <-- new
            eventmanager: '#00B46E', // <-- new
            profile: '#005398', // <-- new
        },
        subtenants: Object.freeze([
        ]),
    },
    /*enterprise: {
        id: 'enterprise',
        name: 'sodisp.com',
        navPostfix: 'minimal',
        title: 'sodisp - Challenge Platform', //TODO
        isDefault: false,
        showFeatures: false,
        accountProviders: ['sodisp', 'garmin', 'strava'],
        scssVariables: 'src/styles/tenants/demo',
        homeUrl: 'https://demo.sodisp.com/',//TODO
        headerLogoUrl: 'https://sodisp.imgix.net/~text?txt-color=fff&txt-pad=0&txt64=RGVtbyBQbGF0Zm9ybQ&txt-font=Avenir%20Next%20Condensed%2CBold&w=200&txt-size=32&fm=png',
        logoUrl: 'https://sodisp.imgix.net/~text?txt-color=F46524&txt-pad=0&txt64=RGVtbyBQbGF0Zm9ybQ&txt-font=Avenir%20Next%20Condensed%2CBold&w=200&txt-size=32&fm=png',
        contactEmail:  'hello@sodisp.com',//TODO
        theme: {
            primary: "#F46524",
            secondary: '#008AFF', // <-- new
            progress: '#FFEB3B', // <-- new //colors.yellow.base,
            accent: '#005398',
            green: '#00B46E',
            header: '#00B46E', // <-- new
            gradient: '#00995B', // <-- new
            eventmanager: '#00B46E', // <-- new
            profile: '#005398', // <-- new
        },
        subtenants: [
            {
                id: 'vruk',
                host: 'vr.co.uk',
                name: 'Virtual Racing UK',
                title: 'Virtual Racing UK',
                contactEmail: 'info@vr.co.uk',
            }
        ],
    },*/
    eventscom: {
        id: 'eventscom',
        name: 'EveryChallenge',
        navPostfix: 'minimal',
        customHomePostfix: 'eventscom',
        title: 'EveryChallenge - Virtual Challenges',
        isDefault: false,
        showFeatures: false,
        accountProviders: ['strava','garmin','sodisp'],
        scssVariables: 'src/styles/tenants/eventscom',
        homeUrl: 'https://everychallenge.events.com/',
        profileFaqUrl: 'https://events.com/faq/',
        eventManagerFaqUrl: 'https://events.com/faq/',
        headerLogoUrl: '/images/eventscom-white.png',
        logoUrl: 'https://events.com/wp-content/themes/events_com_v2/assets/images/logos/events_com_logo.png',
        contactEmail:  'koen@sodisp.com',
        theme: {
            primary: "#ff5722;",
            secondary: '#00bcda', // <-- new
            progress: '#263238', // <-- new
            accent: '#00bcda',
            green: '#00B46E',
            header: '#00bcda', // <-- new
            gradient: '#008DA3', // <-- new
            eventmanager: '#ECEFF1', // <-- new
            profile: '#00bcda', // <-- new
          },
    }
}

module.exports = {
    config: tenantConfig,

    get(tenantId) {
        return this.config[tenantId];
    },
    current() {
        var baseTenantId = process.env.VUE_APP_TENANT;
        if (typeof window === typeof undefined) {
            // compile time
            return this.config[baseTenantId];
        }
        var queryValue = new URLSearchParams(window.location.search).get('tenant');
        var host = window.location.host;
        //console.log('Looking up tenant', baseTenantId, window.location.host, queryValue);
        const baseTenant = this.config[baseTenantId];
        var tenant = null;
        if (baseTenant.subtenants) {
            tenant = baseTenant.subtenants.find(x => x.host == host || x.id == queryValue);
        }
        const mergedTenant = {...baseTenant, ...tenant};
        //console.log('Looked up tenant', baseTenant, tenant, mergedTenant);
        return mergedTenant;
    },
};
//export default tenantConfig;